import Loading from './Loading';

export {
  Loading
};


// WEBPACK FOOTER //
// ./src/views/Loading/index.js